// components/modals/BlockchainModals/DeletePhraseModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { removeTxtExtension } from '../../../services/api.service';
import useModalHistory from '../../../hooks/useModalHistory';

const DeletePhraseModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  phraseName,
  isSingle = true,
  isLoading = false 
}) => {

  useModalHistory(show, onHide, 'phrase-delete-modal');
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="common-modal"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="delete-confirmation">
          <div className="warning-icon mb-3">
            <i className="fas fa-exclamation-triangle"></i>
          </div>
          
          {isSingle ? (
            <p>
              Are you sure you want to delete the secure phrase <strong>{phraseName && removeTxtExtension(phraseName)}</strong>?
              <br />
              This action cannot be undone.
            </p>
          ) : (
            <p>
              Are you sure you want to delete the selected secure phrases?
              <br />
              This action cannot be undone.
            </p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} className="modal-close-btn">
          Cancel
        </Button>
        <Button 
          variant="danger" 
          onClick={onConfirm} 
          disabled={isLoading}
          className="delete-btn"
          id={isSingle ? "confirmDeleteSecurePhraseBtn" : "confirmDeleteSelectedPhrasesBtn"}
        >
          {isLoading ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePhraseModal;